import Checkbox from './Checkbox';
import CheckboxGroup from './Group';
import CheckboxButton from './CheckboxButton';

Checkbox.Group = CheckboxGroup;

/* istanbul ignore next */
Checkbox.install = function(Vue) {
  Vue.component(Checkbox.name, Checkbox);
  Vue.component(CheckboxGroup.name, CheckboxGroup);
  Vue.component(CheckboxButton.name, CheckboxButton);
};

export default Checkbox;
